import PropTypes from 'prop-types';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withCart } from '../../../utils/CartContext';
import { withDigitalData } from '../../../utils/DigitalDataContext';
import ServicesPrices from '../../Prices/ServicesPrices';
import Checkbox from '../../ui/Checkbox/Checkbox';
import SingleChipletSelect from '../../ui/SingleChipletSelect/SingleChipletSelect';
import { getWarrantyLabel } from '../../ui/WarrantySelect/WarrantySelect.helpers';
import { useWarranty } from '../hooks/useWarranty';
import WarrantyModal from '../WarrantyModal';
import { WarrantyStyles } from './style';

const Warranty = ({
  warrantyOptions,
  setWarrantyOption,
  startsFromLabel,
  tooltipToggle,
  additionalWarrantyLabel,
  sellerName,
  digitalData,
  cart,
  appCtx,
}) => {
  const hookData = useWarranty({
    warrantyOptions,
    setWarrantyOption,
    cart,
    appCtx,
    digitalData,
  });

  if (!hookData.shouldRender) {
    return null;
  }

  const {
    labels,
    isImprovedWarrantyUiEnabled,
    tooltipContent,
    selectHandler,
    handleWarrantyChange,
    toggleModalVisibility,
    modalProps,
    offeringId,
    selected,
    textPrice,
    prices,
    discountBadge,
    name,
  } = hookData;

  const { EXTENDED_WARRANTY_LABEL, MORE_WARRANTY_OPTIONS, WARRANTY_LABEL_TEMPLATE } = labels;

  return isImprovedWarrantyUiEnabled ? (
    <>
      <div className="warranty">
        <div className="warranty__header">
          <span className="warranty__icon" />
          <h3 className="warranty__title">{EXTENDED_WARRANTY_LABEL}</h3>
        </div>
        <div className="warranty__container">
          <div className="warranty__option">
            <Checkbox
              id={`warranty-checkbox-${offeringId || 'default'}`}
              isChecked={selected}
              onChange={({ isSelected }) =>
                selectHandler({ offeringId, selected: !isSelected, textPrice, prices, discountBadge, name })
              }
              variant="compact"
              manageState={false}
            >
              <span className="warranty__label">
                {offeringId
                  ? getWarrantyLabel({
                      name,
                      sellerName,
                      warrantyLabelTemplate: WARRANTY_LABEL_TEMPLATE,
                    })
                  : name}
              </span>
            </Checkbox>
          </div>
          <div className="warranty__price">
            {prices ? (
              <ServicesPrices priceList={prices} priceCount={prices.length} discountBadge={discountBadge} />
            ) : (
              <span className="warranty__price-text">{textPrice}</span>
            )}
          </div>
        </div>
        <button
          type="button"
          className="warranty__more-options"
          onClick={toggleModalVisibility}
          aria-label="Ver más opciones de garantía"
        >
          {MORE_WARRANTY_OPTIONS}
        </button>
      </div>
      <WarrantyModal {...modalProps} />
      <style jsx>{WarrantyStyles}</style>
    </>
  ) : (
    <div className="warranty--legacy">
      <SingleChipletSelect
        options={warrantyOptions.fieldOptions}
        cheapestOption={warrantyOptions.fieldOptions[0].price}
        tooltipContent={tooltipContent}
        tooltipToggle={tooltipToggle}
        startsFromLabel={startsFromLabel}
        label={EXTENDED_WARRANTY_LABEL}
        onOptionSelected={handleWarrantyChange}
        secondaryLabelIcon="csicon-alert"
        icon="csicon-shield"
        shouldHaveBackground={false}
        type="medium"
        withPadding={false}
        highLightHeading
        clickableChiplet
        additionalWarrantyLabel={additionalWarrantyLabel}
        serviceType="warranty-option"
        hideSubtitle
      />
    </div>
  );
};

Warranty.defaultProps = {
  setWarrantyOption: () => {},
  warrantyOptions: {
    label: '',
    fieldOptions: [],
  },
  startsFromLabel: 'A partir de: ',
  tooltipToggle: false,
  additionalWarrantyLabel: {},
  sellerName: '',
};

Warranty.propTypes = {
  warrantyOptions: PropTypes.object,
  setWarrantyOption: PropTypes.func,
  startsFromLabel: PropTypes.string,
  tooltipToggle: PropTypes.bool,
  additionalWarrantyLabel: PropTypes.object,
  digitalData: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  sellerName: PropTypes.string,
};

export default withCart(withApplicationContext(withDigitalData(Warranty)));
export { Warranty };
